module.exports = __webpack_public_path__ + "static/media/Services.3d3d2d54.pdf";